<script>
  import Footer from '../components/Footer.svelte';
  import Header from '../components/Header.svelte';
  import { offerPage } from '../data/offer.js';
  import { goBack } from '../utils/router.js';
</script>

<div id="top" class="offer-page">
  <Header />

  <main class="offer-main">
    <div class="offer-shell">
      <button class="back-link" type="button" on:click={goBack}>
        <span class="back-icon" aria-hidden="true"></span>
        <span>{offerPage.backLabel}</span>
      </button>

      <article class="offer-content" aria-labelledby="offer-title">
        <h1 id="offer-title">{offerPage.title}</h1>

        <div class="offer-card">
          <div class="offer-text">
            {#each offerPage.paragraphs as paragraph}
              {#if paragraph === ''}
                <p class="offer-spacer" aria-hidden="true">&nbsp;</p>
              {:else}
                <p>{paragraph}</p>
              {/if}
            {/each}
            <p class="offer-edition">{offerPage.edition}</p>
          </div>
        </div>
      </article>
    </div>
  </main>

  <Footer />
</div>

<style>
  .offer-page {
    min-height: 100vh;
    background: #000000;
    color: #ffffff;
    font-family: Roboto, Arial, Helvetica, sans-serif;
    font-variation-settings: 'wdth' 100;
  }

  .offer-main {
    display: flex;
    justify-content: center;
    overflow: hidden;
    padding: 100px 0;
  }

  .offer-shell {
    display: flex;
    width: min(100%, 1440px);
    flex-direction: column;
    gap: 24px;
    padding: 0 64px;
    box-sizing: border-box;
  }

  .back-link {
    display: inline-flex;
    width: fit-content;
    min-height: 40px;
    align-items: center;
    gap: 12px;
    margin: 0;
    padding: 6px 0;
    border: 0;
    background: transparent;
    color: inherit;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.4;
    cursor: pointer;
  }

  .back-link:hover,
  .back-link:focus-visible {
    color: #e7b962;
  }

  .back-icon {
    display: inline-block;
    width: 7px;
    height: 14px;
    background: currentColor;
    -webkit-mask: url('/icons/ui-icon-chevron-right.svg') center / contain no-repeat;
    mask: url('/icons/ui-icon-chevron-right.svg') center / contain no-repeat;
    transform: rotate(180deg);
  }

  .offer-content {
    display: flex;
    flex-direction: column;
    gap: 48px;
    padding: 40px 0 0;
  }

  h1 {
    margin: 0;
    color: #ffffff;
    font-size: 40px;
    font-weight: 700;
    line-height: 56px;
  }

  .offer-card {
    padding: 40px 30px;
    border: 2px solid #ffa800;
    border-radius: 16px;
    background: rgba(0, 0, 0, 0.72);
    box-sizing: border-box;
  }

  .offer-text {
    display: flex;
    flex-direction: column;
    color: #ffffff;
    font-size: 32px;
    font-weight: 400;
    line-height: 50px;
  }

  .offer-text p {
    margin: 0;
  }

  .offer-spacer {
    height: 50px;
  }

  .offer-edition {
    padding-top: 50px;
  }

  @media (max-width: 1279px) {
    .offer-main {
      padding: 100px 0;
    }

    .offer-shell {
      gap: 24px;
      padding: 0 32px;
    }

    h1 {
      font-size: 36px;
    }
  }

  @media (max-width: 767px) {
    .offer-main {
      padding: 100px 0 40px;
    }

    .offer-shell {
      padding: 0 24px;
    }

    .offer-content {
      gap: 24px;
    }

    h1 {
      font-size: 24px;
      line-height: 32px;
    }

    .offer-card {
      padding: 24px 16px;
    }

    .offer-text {
      font-size: 18px;
      line-height: 24px;
    }

    .offer-spacer {
      height: 24px;
    }

    .offer-edition {
      padding-top: 24px;
    }
  }
</style>
